<mydocma-app-container [options]="containerOptions" class="document-preview-container">
  <div mydocma-header-item-left class="project-name">{{ projectName }}</div>
  <div mydocma-header-item-right>
    <button
      class="message-center-button"
      mat-icon-button
      (click)="toggleMessageCenter()"
      [ngClass]="{ toggleColor: (appRightDrawerService.isOpen | async) }"
      [matTooltip]="'shareMain.messageCenterTooltip' | translate"
      [matTooltipPosition]="'below'"
      matTooltipClass="message-tooltip"
    >
      <mydocma-custom-mat-icon [iconName]="'_megaphone_outline'"></mydocma-custom-mat-icon>
    </button>
  </div>
</mydocma-app-container>